<script lang="ts">
import { writable } from "svelte/store";
import { find, findResult } from "../api";

import Loading from "../components/loading/Loading.svelte";
import Table from "../components/table/Table.svelte";
import LocalSort from "../components/table/LocalSort.svelte";
import LocalSearch from "../components/table/LocalSearch.svelte";
import { onMount } from "svelte";
import { fileSize } from "../tools";
import { activePage } from "../router";
import { path } from "./Browser.svelte";


const data          = writable(findResult());
const isLoading     = writable(false);

function browse (p: string) {
	$activePage = "browser";
	$path       = p;
}

async function getData (path?: string) {
	$isLoading = true;

	try {
		$data = await find(
			"/users"
		);
	} catch (e) {
	}

	$isLoading = false;
}
onMount(getData);
</script>

<div class="users">
	<LocalSort data="{$data.result}" sortKey="usage.total" sortDir="desc" let:sorted let:sortBy let:sortKey let:sortDir>
		<LocalSearch data="{sorted}" let:filtered>
			<div class="row" slot="search" let:regex >
				<table class="table table-dark bg-secondary mb-0">
					<tbody>
						<tr>
							<td class="align-middle" width="100">
								<label for="search-alias" class="form-label mb-0">Alias</label>
							</td>
							<td width="300">
								<input type="search" id="search-alias" class="form-control" on:input={(e) => { regex(e, "alias") }}>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="row position-relative">
				<Table data="{filtered}" class="table table-fixed table-dark">
					<tr slot="thead">
						<th width="30%" class="th-pointer" on:click="{( ) => sortBy("id", "asc")}">
							ID
							{#if sortKey === "id"}
								{#if sortDir === "asc"}⬇{:else}⬆{/if}
							{/if}
						</th>
						<th width="30%" class="th-pointer" on:click="{( ) => sortBy("alias", "asc")}">
							Alias
							{#if sortKey === "alias"}
								{#if sortDir === "asc"}⬇{:else}⬆{/if}
							{/if}
						</th>
						<th width="16%">Browse</th>
						<th width="8%" class="th-pointer" on:click="{( ) => sortBy("usage.import", "desc")}">
							Import
							{#if sortKey === "usage.import"}
								{#if sortDir === "asc"}⬇{:else}⬆{/if}
							{/if}
						</th>
						<th width="8%" class="th-pointer" on:click="{( ) => sortBy("usage.upload", "desc")}">
							Upload
							{#if sortKey === "usage.upload"}
								{#if sortDir === "asc"}⬇{:else}⬆{/if}
							{/if}
						</th>
						<th width="8%" class="th-pointer" on:click="{( ) => sortBy("usage.total", "desc")}">
							Total
							{#if sortKey === "usage.total"}
								{#if sortDir === "asc"}⬇{:else}⬆{/if}
							{/if}
						</th>
					</tr>
					<tr slot="tbody" let:item>
						<td>
							{item.id}
						</td>
						<td>
							{item.alias}
						</td>
						<td>
							<a href="import" on:click|preventDefault="{( ) => browse(`/import/${item.id}`)}"><i class="fas fa-folder"></i> import</a>
							&nbsp; | &nbsp;
							<a href="upload" on:click|preventDefault="{( ) => browse(`/upload/${item.id}`)}"><i class="fas fa-folder"></i> upload</a>
						</td>
						<td>
							{fileSize(item.usage.import * 1000)}
						</td>
						<td>
							{fileSize(item.usage.upload * 1000)}
						</td>
						<td>
							{fileSize(item.usage.total * 1000)}
						</td>
					</tr>
				</Table>
				<Loading class="bg-dark" isLoading={$isLoading} duration="{25}"><div class="loading-spinner"></div></Loading>
			</div>
		</LocalSearch>
	</LocalSort>
</div>
